export default __webpack_public_path__ + "static/media/google-play-badge.68ee8ec7.svg";